module.exports = {
	"articleTitle1": "Ben & Jerry's co-founder highlights social activism in Entrepalooza ...",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Ben and Jerry's",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/ben-jerrys-and-stucchis-make-it-work",
	"articleSnippet1": "Sep 23, 2016 ... Entrepalooza served up a sweet treat to aspiring entrepreneurs Friday night in \nthe Michigan League. Ben & Jerry's co-founder Jerry Greenfield ...",
	"articleSnippet2": "Sep 25, 2007 ... When Ben & Jerry's owner Matt Arthur took over the State Street shop from its \nprevious owners in May 2006, he often paid attention to the flow ...",
	"foodRecommendations": [
		{
			"text": "It's your standard B&J's. I really like their shakes.",
			"person": "Erik Forkin"
		}
	],
	"articleTitle2": "Ben & Jerry's and Stucchi's make it work",
	"address": "304 S State St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279075,
		"lng": -83.741064
	},
	"totalMisc": 0,
	"categories": {
		"dessert": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/benandjerrys.json
// module id = 826
// module chunks = 0